export default __webpack_public_path__ + "static/media/grandpa.a756d8cd.ogg";